import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import OrdersPage from "@/pages/OrdersPage";

import ClientsPage from "@/pages/ClientsPage";
import InventoryPage from "@/pages/InventoryPage";
import ReportsPage from "@/pages/ReportsPage";
import UsersPage from "@/pages/UsersPage";
import ManualPage from "@/pages/ManualPage";
import ConfigPage from "@/pages/ConfigPage";
import ProductsPage from "@/pages/ProductsPage";
import ExpeditionPage from "@/pages/ExpeditionPage";
import EngineeringPage from "@/pages/EngineeringPage";
import AuditPage from "@/pages/AuditPage";
import { Toaster } from "sonner";
import { firstAllowedPath } from "@/lib/permissions";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-muted-foreground text-sm">Carregando...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PermRoute({ children, module }) {
  const { user, can } = useAuth();
  if (!user || !can(module, "view")) {
    const target = firstAllowedPath(user);
    return target === window.location.pathname ? <ManualPage /> : <Navigate to={target} replace />;
  }
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<PermRoute module="dashboard"><DashboardPage /></PermRoute>} />
        <Route path="ordens" element={<PermRoute module="ordens"><OrdersPage /></PermRoute>} />
        <Route path="produtos" element={<PermRoute module="produtos"><ProductsPage /></PermRoute>} />
        <Route path="clientes" element={<PermRoute module="clientes"><ClientsPage /></PermRoute>} />
        <Route path="estoque" element={<PermRoute module="estoque"><InventoryPage /></PermRoute>} />
        <Route path="relatorios" element={<PermRoute module="relatorios"><ReportsPage /></PermRoute>} />
        <Route path="usuarios" element={<PermRoute module="usuarios"><UsersPage /></PermRoute>} />
        <Route path="configuracoes" element={<PermRoute module="configuracoes"><ConfigPage /></PermRoute>} />
        <Route path="expedicao" element={<PermRoute module="expedicao"><ExpeditionPage /></PermRoute>} />
        <Route path="engenharia" element={<PermRoute module="engenharia"><EngineeringPage /></PermRoute>} />
        <Route path="auditoria" element={<PermRoute module="auditoria"><AuditPage /></PermRoute>} />
        <Route path="manual" element={<ManualPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
